import type { PlayerUser } from "Models";
import { Gender } from "types/enums";
import { FaGolfBall, FaStar } from "react-icons/fa";
import { teeTypeIconColorHelper } from "utils/icons/iconHelpers";
import { teeTypeDisplayNameKeyedByString } from "utils/enums/enumHelper";

type FormatOptionLabelContext = "menu" | "value";

const FormattedUserSearchOption = ({
  value,
  context,
  currentFacilityId,
}: {
  value: PlayerUser;
  context: FormatOptionLabelContext;
  currentFacilityId?: string;
}) => {
  const isFavorite =
    currentFacilityId && value.favoriteFacilityId === currentFacilityId;

  return context === "menu" ? (
    <div className="w-full text-left flex items-center justify-start gap-1">
      <span className="inline-flex items-center translate-y-[-1px]">
        <FaGolfBall
          className={`${isFavorite ? "mr-.5" : "mr-2"} shrink-0 ${
            teeTypeIconColorHelper[value.teeType?.toString()]
          }`}
          title={`This user prefers playing from the ${
            teeTypeDisplayNameKeyedByString[value.teeType]
          } tees`}
        />
      </span>
      {isFavorite && (
        <span className="inline-flex items-center translate-y-[-1px]">
          <FaStar
            className="text-yellow-400 shrink-0"
            title="This user has favorited this facility"
          />
        </span>
      )}
      {value.displayName ? (
        <strong className="flex items-center">
          {value.displayName}
          <span className="ml-1 text-xs">({Gender[value.gender]?.[0]})</span>
        </strong>
      ) : null}
      {value.displayName && value.displayName !== value.username ? (
        <span className="text-gray-600">
          | <i className="mr-1">{value.username}</i>
        </span>
      ) : null}
      {value.email ? (
        <span className="text-gray-500">| {value.email}</span>
      ) : null}
    </div>
  ) : (
    <div>{value.username || value.displayName || value.email}</div>
  );
};
export default FormattedUserSearchOption;
